<script setup lang="ts">
/**
 * Where a decision card points before you decide, on the far edge of its row (ZhDecisionActions' `link` slot):
 * Preview, in a new tab, when the gate carries a preview address; else its run.
 */
import { RouterLink } from 'vue-router'
import type { GateRow } from '@/api'

defineProps<{ gate: Pick<GateRow, 'runId' | 'previewUrl'> }>()
</script>

<template>
	<a v-if="gate.previewUrl" :href="gate.previewUrl" target="_blank" rel="noopener noreferrer">Preview →</a>
	<RouterLink v-else :to="`/runs/${gate.runId}`">Open run →</RouterLink>
</template>
